<template>
  <v-row no-gutters>
    <!-- <v-card width="100"> -->
    <v-card-title class="grey--text text-subtitle-1">
      Fitofarmaci in Carico
      <v-spacer />
      <v-dialog v-model="dialog_nuovo" width="800">
        <template v-slot:activator="{ on }">
          <v-btn outlined color="green" v-on="on" class="ml-8"
            ><v-icon class="mr-2">mdi-medication</v-icon>Aggiungi
            Fitofarmaco</v-btn
          >
        </template>
        <v-card>
          <v-card-title class="grey--text text-subtitle-1">
            <v-icon color="green" class="mr-2">mdi-medication</v-icon>
            Nuovo Carico
            <v-spacer />
            <v-dialog width="800" v-model="dialog_aggiorna">
              <template v-slot:activator="{ on }">
                <v-btn color="indigo" outlined v-on="on" class="ml-4"
                  ><v-icon>mdi-update</v-icon> Aggiorna</v-btn
                >
              </template>
              <v-card>
                <v-card-title class="grey--text text-subtitle-1">
                  <v-icon color="indigo" class="mr-2"
                    >mdi-database-refresh-outline</v-icon
                  >
                  Aggiornamento Database Fitofarmaci
                </v-card-title>
                <v-divider />
                <v-card-text class="pt-5">
                  <div class="text-overline grey--text text--darken-1">
                    Sorgente dati
                  </div>
                  <v-text-field
                    v-model="url_json"
                    label="Url json"
                    :loading="scraping_url"
                    :hint="
                      scraping_url
                        ? 'Rilevamento automatico dell\'URL in corso...'
                        : 'Rilevato automaticamente dal sito del Ministero: verificalo prima di inviare'
                    "
                    persistent-hint
                    outlined
                  >
                    <template v-slot:prepend-inner>
                      <v-icon small :color="scraping_url ? 'indigo' : 'grey'"
                        >mdi-web</v-icon
                      >
                    </template>
                    <template v-slot:append>
                      <v-tooltip top v-if="!loading_url">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            class="mt-n1"
                            :disabled="scraping_url"
                            v-bind="attrs"
                            v-on="on"
                            @click="fito_update_url"
                            ><v-icon>mdi-content-save-outline</v-icon></v-btn
                          >
                        </template>
                        <span>Salva URL</span>
                      </v-tooltip>
                      <v-progress-circular
                        v-else
                        width="2"
                        indeterminate
                        color="indigo"
                      ></v-progress-circular>
                    </template>
                  </v-text-field>
                  <v-row
                    v-if="sorgente_info"
                    no-gutters
                    class="mt-2 mb-1"
                    style="gap: 8px; flex-wrap: wrap"
                  >
                    <v-chip
                      v-if="sorgente_info.data_aggiornamento"
                      small
                      outlined
                      color="indigo"
                    >
                      <v-icon left small>mdi-calendar-clock-outline</v-icon>
                      Aggiornato il {{ sorgente_info.data_aggiornamento }}
                    </v-chip>
                    <v-chip
                      v-if="sorgente_info.frequenza_aggiornamento"
                      small
                      outlined
                      color="grey darken-1"
                    >
                      <v-icon left small>mdi-refresh</v-icon>
                      {{ sorgente_info.frequenza_aggiornamento }}
                    </v-chip>
                    <v-chip
                      v-if="sorgente_info.unita_organizzativa"
                      small
                      outlined
                      color="grey darken-1"
                    >
                      <v-icon left small>mdi-office-building-outline</v-icon>
                      {{ sorgente_info.unita_organizzativa }}
                    </v-chip>
                  </v-row>
                  <v-snackbar v-model="avviso_scraping_error" top color="orange">
                    <v-icon class="mr-2">mdi-alert</v-icon>
                    {{ scraping_error_message }}. Inserisci l'URL manualmente.
                  </v-snackbar>

                  <div
                    class="text-overline grey--text text--darken-1 mt-2 d-flex align-center"
                  >
                    Scansione
                    <v-chip
                      v-if="!scan_enable && fase_label"
                      x-small
                      class="ml-2"
                      color="indigo"
                      text-color="white"
                      >{{ fase_label }}</v-chip
                    >
                  </div>
                  <v-row dense>
                    <v-col cols="4">
                      <v-sheet outlined rounded class="pa-3 text-center">
                        <div class="text-h5 indigo--text text--darken-1">
                          {{ fito_progress.processati }}
                        </div>
                        <div class="text-caption grey--text">Processati</div>
                      </v-sheet>
                    </v-col>
                    <v-col cols="4">
                      <v-sheet outlined rounded class="pa-3 text-center">
                        <div class="text-h5 green--text text--darken-1">
                          {{ fito_progress.aggiunti }}
                        </div>
                        <div class="text-caption grey--text">Aggiunti</div>
                      </v-sheet>
                    </v-col>
                    <v-col cols="4">
                      <v-sheet outlined rounded class="pa-3 text-center">
                        <div class="text-h5 orange--text text--darken-1">
                          {{ fito_progress.aggiornati }}
                        </div>
                        <div class="text-caption grey--text">Aggiornati</div>
                      </v-sheet>
                    </v-col>
                  </v-row>
                  <v-progress-linear
                    class="mt-4"
                    rounded
                    color="indigo"
                    height="22"
                    :indeterminate="fito_progress.fase === 'download'"
                    :value="fito_progress.percent"
                    ><span
                      v-if="fito_progress.fase !== 'download'"
                      class="white--text text-caption font-weight-medium"
                      >{{ fito_progress.percent.toFixed(1) }}%</span
                    >
                  </v-progress-linear>
                </v-card-text>
                <v-divider />
                <v-snackbar v-model="avviso_scan_error" top color="red">
                  <v-icon class="mr-2">mdi-alert</v-icon>
                  {{ scan_error_message }}
                </v-snackbar>
                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    outlined
                    color="orange darken-1"
                    :disabled="!scan_enable"
                    :loading="!scan_enable"
                    @click="fito_update()"
                    ><v-icon class="mr-2">mdi-cloud-download-outline</v-icon
                    >Scansiona</v-btn
                  >
                  <v-btn text color="grey" @click="dialog_aggiorna = false"
                    >chiudi</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-card-title>
          <v-snackbar v-model="avviso_exist" top shaped color="red">
            <v-icon class="mr-2">mdi-alert</v-icon>
            Attenzione. Il fitofarmaco selezionato è già presente
          </v-snackbar>
          <v-card-text>
            <v-autocomplete
              v-model="id_prodotto_sel"
              :items="items"
              :loading="isLoading"
              :search-input.sync="search"
              chips
              clearable
              hide-details
              hide-selected
              item-text="prodotto"
              item-value="_id.$oid"
              label="Ricerca Prodotto..."
              placeholder="Digita almeno 3 caratteri per cercare..."
              outlined
            >
              <template v-slot:prepend-inner>
                <v-icon color="grey">mdi-magnify</v-icon>
              </template>
            </v-autocomplete>

            <v-sheet v-if="fitof_select" outlined rounded class="pa-4 mt-5">
              <div class="d-flex align-start">
                <div class="flex-grow-1">
                  <div class="text-h6">{{ fitof_select.prodotto }}</div>
                  <div class="text-caption grey--text">
                    <v-icon x-small class="mr-1">mdi-pound</v-icon
                    >Registrazione {{ fitof_select.numero_registrazione }}
                  </div>
                </div>
                <v-chip :color="stato_chip_color" text-color="white" small
                  ><v-icon left small>{{ stato_chip_icon }}</v-icon
                  >{{ fitof_select.stato_amministrativo || "N/D" }}</v-chip
                >
              </div>

              <v-divider class="my-3" />

              <v-row dense>
                <v-col cols="12" sm="6">
                  <div class="text-caption grey--text">
                    <v-icon x-small class="mr-1">mdi-domain</v-icon>Titolare
                    Registrazione
                  </div>
                  <div>{{ fitof_select.impresa || "-" }}</div>
                </v-col>
                <v-col cols="12" sm="6">
                  <div class="text-caption grey--text">
                    <v-icon x-small class="mr-1"
                      >mdi-calendar-outline</v-icon
                    >Data Registrazione
                  </div>
                  <div>{{ fitof_select.data_registrazione || "-" }}</div>
                </v-col>
                <v-col cols="12" sm="6">
                  <div class="text-caption grey--text">
                    <v-icon x-small class="mr-1">mdi-calendar-alert</v-icon
                    >Scadenza Autorizzazione
                  </div>
                  <div>{{ fitof_select.scadenza_autorizzazione || "-" }}</div>
                </v-col>
                <v-col cols="12" sm="6">
                  <div class="text-caption grey--text">
                    <v-icon x-small class="mr-1">mdi-cancel</v-icon>Decorrenza
                    Revoca
                  </div>
                  <div>{{ fitof_select.data_decorrenza_revoca || "-" }}</div>
                </v-col>
              </v-row>

              <v-divider class="my-3" />

              <v-row dense>
                <v-col cols="12">
                  <div class="text-caption grey--text">
                    <v-icon x-small class="mr-1">mdi-flask-outline</v-icon
                    >Sostanze Attive
                  </div>
                  <div>{{ fitof_select.sostanze_attive || "-" }}</div>
                </v-col>
                <v-col cols="12" sm="6">
                  <div class="text-caption grey--text">
                    <v-icon x-small class="mr-1">mdi-target</v-icon>Attività
                  </div>
                  <div>{{ fitof_select.attivita || "-" }}</div>
                </v-col>
                <v-col cols="12" sm="6">
                  <div class="text-caption grey--text">
                    <v-icon x-small class="mr-1">mdi-beaker-outline</v-icon
                    >Formulazione
                  </div>
                  <div>{{ fitof_select.descrizione_formulazione || "-" }}</div>
                </v-col>
                <v-col cols="12">
                  <div class="text-caption grey--text">
                    <v-icon x-small class="mr-1" color="orange darken-2"
                      >mdi-alert-octagon-outline</v-icon
                    >Indicazioni di Pericolo
                  </div>
                  <div>{{ fitof_select.indicazioni_di_pericolo || "-" }}</div>
                </v-col>
              </v-row>
            </v-sheet>
            <v-row v-else justify="center" class="mt-8 mb-4">
              <div class="text-center grey--text">
                <v-icon color="grey lighten-1" size="40"
                  >mdi-flask-empty-outline</v-icon
                >
                <div class="text-caption mt-1">Nessun prodotto selezionato</div>
              </div>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              outlined
              color="green"
              :disabled="!fitof_select"
              :loading="loading_invio"
              @click="aggiungi_prodotto_fito"
              ><v-icon class="mr-2">mdi-plus</v-icon>Aggiungi</v-btn
            >
            <v-btn text color="grey" @click="dialog_nuovo = false"
              >chiudi</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card-title>
    <v-card-text>
      <template v-if="fitofarmaci_magazzino.length">
        <v-row class="text-caption grey--text text--darken-1 text-uppercase font-weight-medium">
          <v-col cols="3"> Nome Prodotto </v-col>
          <v-col cols="2"> Sostanza Attiva </v-col>
          <v-col cols="2"> Stato Amministrativo </v-col>
          <v-col cols="2"> Scadenza Autorizzazione </v-col>
          <v-col cols="1"> In Magazzino </v-col>
          <v-col cols="2"> Azioni </v-col>
        </v-row>
        <v-divider class="my-2" />
        <FitoElement
          v-for="fito in fitofarmaci_magazzino"
          :key="fito.id"
          :fito="fito"
        />
      </template>
      <v-row v-else justify="center" class="my-8">
        <div class="text-center grey--text">
          <v-icon color="grey lighten-1" size="40">mdi-medication-outline</v-icon>
          <div class="text-caption mt-1">
            Nessun fitofarmaco in magazzino. Usa "Aggiungi Fitofarmaco" per
            iniziare.
          </div>
        </div>
      </v-row>
    </v-card-text>
    <!-- </v-card> -->
  </v-row>
</template>

<script>
import FitoElement from "./fitofarmaco_element.vue";
import fito_tab_mixin from "../mixin/fitofarmaco_tab_mixin";
import { statoChipColor, statoChipIcon } from "../mixin/fitofarmaco_stato_utils";
export default {
  components: {
    FitoElement,
  },
  mixins: [fito_tab_mixin],
  data() {
    return {
      scan_enable: true,
      dialog_aggiorna: false,
      avviso_scan_error: false,
      scan_error_message: "",
    };
  },
  watch: {
    dialog_aggiorna(val) {
      if (val) {
        this.scopri_url_fitofarmaci();
      }
    },
  },
  computed: {
    fito_progress() {
      return this.$store.getters.get_fito_update;
    },
    fase_label() {
      switch (this.fito_progress.fase) {
        case "download":
          return "Download in corso...";
        case "scansione":
          return "Scansione";
        case "inserimento":
          return "Inserimento nuovi prodotti...";
        case "aggiornamento":
          return "Aggiornamento stato/scadenze...";
        case "completato":
          return "Completato";
        default:
          return "";
      }
    },
    stato_chip_color() {
      return statoChipColor(this.fitof_select && this.fitof_select.stato_amministrativo);
    },
    stato_chip_icon() {
      return statoChipIcon(this.fitof_select && this.fitof_select.stato_amministrativo);
    },
  },
  methods: {
    fito_update() {
      this.scan_enable = false;
      this.avviso_scan_error = false;
      // Reset ottimistico: non aspettiamo il round-trip del socket per
      // togliere di mezzo la percentuale/fase lasciata dall'ultima
      // scansione, altrimenti per un istante sembra che il progresso non
      // si sia mosso o che lo scan sia già concluso.
      this.$store.commit("set_fito_update", {
        fase: "download",
        processati: 0,
        aggiunti: 0,
        aggiornati: 0,
        percent: 0,
      });
      this.$store
        .dispatch("fito_update")
        .catch((err) => {
          this.scan_error_message =
            (err.response && err.response.data && err.response.data.message) ||
            "Errore durante l'aggiornamento del database fitofarmaci";
          this.avviso_scan_error = true;
        })
        .finally(() => {
          this.scan_enable = true;
        });
    },
  },
  // data() {
  //   return {
  //     dialog_nuovo: false,
  //     id_prodotto_sel: null,
  //     tab_loading: false,
  //     isLoading: false,
  //     loading_invio: false,
  //     items: [],
  //     search: null,
  //   };
  // },
  // watch: {
  //   search(val) {
  //     // Items have already been loaded
  //     if (val.length < 3) {
  //       return;
  //     }
  //     if (this.isLoading) {
  //       return;
  //     }

  //     this.isLoading = true;

  //     // Lazily load input items
  //     fetch(process.env.VUE_APP_API_ROOT + "/admin/fitofarmaco/" + this.search)
  //       .then((res) => res.clone().json())
  //       .then((res) => {
  //         this.items = res;
  //       })
  //       .catch((err) => {
  //       })
  //       .finally(() => (this.isLoading = false));
  //   },
  // },
  // computed: {
  //   fitof_select() {
  //     return this.items.find((fito) => fito._id.$oid == this.id_prodotto_sel);
  //   },
  //   fitofarmaci_magazzino() {
  //     return this.$store.getters.get_fitofarmaci;
  //   },
  // },
  // methods: {
  //   aggiungi_prodotto_fito() {
  //     this.loading_invio = true;
  //     this.$store
  //       .dispatch("add_prodotto_fito", this.id_prodotto_sel)
  //       .then((res) => {
  //         this.loading_invio = false;
  //         if(res == 'exist'){

  //         }else{

  //         }
  //         this.dialog_nuovo = false;
  //       });
  //   },
  // },
};
</script>